<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="950px"
      v-bind:body-style="{ height: '500px',overflowY:'auto' }"
    >
    <!-- 表单 -->
    <div class="body">
      <div class="body-content">
        <!-- 表头 -->
      <div class="content_one" style="margin-top: -15px;">
        <div class="form_title">收获地址</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_address.field"
          :data-source="relevanceBatch_grid_address.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_address.height,x:relevanceBatch_grid_address.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">商品信息</div>
        </div>

        <!-- 表格 -->
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_cost.field"
          :data-source="relevanceBatch_grid_cost.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_cost.height,x:relevanceBatch_grid_cost.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
          <!-- 图例 -->
          <span slot="imgUrl" slot-scope="text, record">
            <img
              v-if="record.pictList.length > 0"
              style="height: 50px;max-width: 100%; margin-right: 4px"
              :src="url + record.pictList[0].id"
              @click="handleImg(record.pictList[0].id)"
            />
          </span>
          <template slot="footer" style="display: flex;">
            <div style="flex: 6;">
            </div>
            <span style="flex: 1;text-align: center;">合计：{{total}}</span>
          </template>
        </a-table>

        <div style="font-size: 16px;margin-top: 20px;margin-bottom: 10px;">赠品</div> 
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_grid_gifts.field"
          :data-source="relevanceBatch_grid_gifts.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_grid_gifts.height,x:relevanceBatch_grid_gifts.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index" :key="index">
            {{index+1}}
          </span>
          <!-- 图例 -->
          <span slot="imgUrl" slot-scope="text, record">
            <img
              v-if="record.pictList.length > 0"
              style="height: 50px;max-width: 100%;margin-right: 4px"
              :src="url + record.pictList[0].id"
              @click="handleImg(record.pictList[0].id)"
            />
          </span>
        </a-table>

        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">物流信息</div>
        </div>

        <!-- 展示框 -->
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="logisticsList" :rules="rules" ref="ruleForm">
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="物流公司:" prop="logisticsComp">
                <a-input v-model="logisticsList.logisticsComp" :allowClear="true"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="运单号:" prop="waybillNum">
                <a-input v-model="logisticsList.waybillNum" :allowClear="true"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancelImg"
      class="imgBox"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import {
  queryOrderDetail
} from "@/api/api.js";
export default {
  props: {
    modalTitle: {
      type: String,
      default: () => "订单发货",
    }, //标题
    type: {
      type: String,
      default: () => ""
    },//返回信息
    orderNo: {
      type: String,
      default: () => ""
    },//这条数据orderNo
  },
  data() {
    return {
      visible: true,

      //图片
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      previewVisible: false,
      previewImage: "",

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //物流信息
      orderLogistics:{},
      logisticsList: {
        logisticsComp: "",
        waybillNum:""
      },

      //校验规则
      rules: {
        logisticsComp: [
          {
            required: true,
            message: "物流公司不能为空！",
            trigger: "blur",
          },
          {
            max: 100,
            message: "不可超过100字",
            trigger: "blur",
          },
        ],
        waybillNum: [
          {
            required: true,
            message: "运单号不能为空！",
            trigger: "blur",
          },
          {
            max: 50,
            message: "不可超过50字",
            trigger: "blur",
          },
        ],
      },

      //收货地址
      relevanceBatch_grid_address: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 40,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "收货人",
            align: "center",
            width: 110,
            dataIndex: "consignee",
            ellipsis: true,
          },
          {
            title: "手机号",
            align: "center",
            width: 110,
            dataIndex: "phoneNo",
            ellipsis: true,
          },
          // {
          //   title: "运费",
          //   align: "center",
          //   width: 110,
          //   dataIndex: "phone",
          //   ellipsis: true,
          // },
          {
            title: "发货时间",
            colSpan: 1,
            width: 110,
            dataIndex: "createTime",
            align: "center",
            ellipsis: true,
          },
          // {
          //   title: "确认收货时间",
          //   colSpan: 1,
          //   align: "center",
          //   width: 110,
          //   ellipsis: true,
          //   dataIndex: "orderSource",
          //   scopedSlots: {
          //     customRender: "orderSource",
          //   },
          // },
          {
            title: "收货地址",
            colSpan: 1,
            align: "center",
            width: 300,
            ellipsis: true,
            dataIndex: "receivAddress",
          },
        ]
      },

      //费用信息
      relevanceBatch_grid_cost: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 35,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品图片",
            align: "center",
            width: 100,
            dataIndex: "imgUrl",
            ellipsis: true,
            scopedSlots: {
              customRender: "imgUrl",
            }
          },
          {
            title: "商品名称",
            align: "center",
            width: 140,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "商品单价",
            align: "center",
            width: 50,
            dataIndex: "prPrice",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            align: "center",
            width: 50,
            ellipsis: true,
            dataIndex: "prCount",
          },
          {
            title: "商品说明",
            colSpan: 1,
            width: 170,
            dataIndex: "remark",
            align: "center",
            ellipsis: true,
          },
          {
            title: "小计",
            colSpan: 1,
            align: "center",
            width: 70,
            ellipsis: true,
            dataIndex: "goodTotalPrice",
          },
        ]
      },

      //赠品
      relevanceBatch_grid_gifts: {
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            width: 35,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品图片",
            align: "center",
            width: 100,
            dataIndex: "imgUrl",
            ellipsis: true,
            scopedSlots: {
              customRender: "imgUrl",
            }
          },
          {
            title: "商品名称",
            align: "center",
            width: 140,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "商品单价",
            align: "center",
            width: 50,
            dataIndex: "prPrice",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            align: "center",
            width: 50,
            ellipsis: true,
            dataIndex: "prCount",
          },
          {
            title: "商品说明",
            colSpan: 1,
            width: 170,
            dataIndex: "remark",
            align: "center",
            ellipsis: true,
          },
          {
            title: "小计",
            colSpan: 1,
            align: "center",
            width: 70,
            ellipsis: true,
            dataIndex: "goodTotalPrice",
          },
        ]
      },
    }
  },
  mounted() {
    // 获取字典
    // DictionaryService.getAllNeedDic(["ORDER_STATUS"]).then((res) => {
    //   //查询
    //   this.queryList();
    // }); 
    //查询
    this.queryList();
    this.relevanceBatch_grid_address.width = 0;
    this.relevanceBatch_grid_address.field.map(item => {
      this.relevanceBatch_grid_address.width += item.width;
    });

    this.relevanceBatch_grid_cost.width = 0;
    this.relevanceBatch_grid_cost.field.map(item => {
      this.relevanceBatch_grid_cost.width += item.width;
    });

    this.relevanceBatch_grid_gifts.width = 0;
    this.relevanceBatch_grid_gifts.field.map(item => {
      this.relevanceBatch_grid_gifts.width += item.width;
    });
  },
  computed: {
    total() {
      var sum = 0;
      this.relevanceBatch_grid_cost.row.forEach(item => {
        sum += Number(item.goodTotalPrice);
      });
      return sum.toFixed(2);
    }
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleOk",this.logisticsList,this.orderLogistics); 
        }
      });
    },

    //查询接口
    queryList() {
      queryOrderDetail({
        orderNo:this.orderNo,
      }).then(res => {
        let obj = [];
        obj.push(res.content)
        this.relevanceBatch_grid_gifts.row = obj[0].giftawayList;
        this.relevanceBatch_grid_cost.row = obj[0].productBaseMsgList;
        //收获地址 地址没有的话隐藏物流信息、时间轴、收获地址
        if (obj[0].receivAddress == null) {
          this.addressVisible = false;
        } else {
          let array = [];
          array.push(obj[0].receivAddress);
          this.relevanceBatch_grid_address.row = array;
          //物流信息
          if (obj[0].orderLogistics != null) {
            this.orderLogistics = obj[0].orderLogistics;
            this.logisticsList.logisticsComp = obj[0].orderLogistics['logisticsComp'];
            this.logisticsList.waybillNum = obj[0].orderLogistics['waybillNum'];
          }
        }
      });
    },

    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.previewImage = this.url + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },


  },
}
</script>

<style lang="less" scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}

.body {
    display: flex;
    justify-content: space-between;
    height: 88%;
    background: #fff;
    .body-content {
      flex: 1;
      height: 100%;

      .content_one{
        height: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        
      }
    }
  }

.form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #16828b;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

/deep/.ant-table-footer{
  display: flex !important;
}
</style>
